import styled, { css } from 'styled-components';
import { breakpoint } from 'styles/globals';
import { getIcon } from 'styles/icons';
import { getColor, type Theme } from 'styles/theme';
import Button from 'components/Globals/Base/Button';

export const VisibleContributorsWrapper = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;

`;

export const SeeMoreAuthorsWrapper = styled.div`
  display: flex;
  position: relative;
  gap:16px;
  margin-top: 16px;
`;

export const MoreContributorsWrapper = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 16px;
`;

export const CloseDropdown = styled.div<{ theme: Theme }>`
  align-self: end;
  cursor: pointer;
  height: 21px;
  width: 16px;
  ${getIcon('svg-states')};

  &::before {
    ${getIcon('close-icon', { height: 15, width: 11 })};
    margin: auto;
  };
`;

export const CompactBylineWrapper = styled.div<{ theme: Theme }>`
  display: flex;
  align-items: flex-start;  
  justify-content: space-between;
  gap: 16px;

  @media (${breakpoint.mdMin}) {
    display: none
  }
`;

export const DesktopBylineWrapper = styled.div<{ theme: Theme }>`
 display: none;
 .social-icon {
    svg {
      fill: ${getColor('iconPrimary')};
    }
 }

  @media (${breakpoint.mdMin}) {
    display: block;

    .tooltip-author {
      &::before {
        border-bottom: 4px solid ${getColor('borderBlack')};
      }
    }
  }
`;

export const SeeMoreButton = styled(Button)<{ theme: Theme }>`
  font-size: 0.875rem;
  align-self: flex-start;  

  &:hover, &:active, &:focus {
    text-decoration: none;
  }
  &::after {
    transition: all 0.3s ease;
  }
`;

const animation = css`
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

export const CollapsedView = styled.div<{ theme: Theme; $isExpanded: boolean; $hasExpanded: boolean }>`
  display: flex;
  gap: 8px;
  &.socialShare{
    flex-direction: column;
  }
  .author-item {
    &:after {
      content: ',';
    }
  }
  .author-item:last-child:after {
    ${({ $isExpanded, $hasExpanded }) => {
      if (!$hasExpanded) return `content: none;`;
      if (!$isExpanded) return `content: '...';`;
      return '';
    }}
  }
  ${animation};
  animation: fadeIn 0.3s;
`;

export const ExpandedView = styled.div<{ theme: Theme; $isVisible: boolean }>`
  display: flex;
  flex-wrap: wrap;
  gap: 0px 16px;
  animation: fadeIn 0.3s;
  .author-item {
    &:after {
      content: ',';
    }
  }
  .author-item:last-child {
    &:after {
      content: '';
    }
  } 
  ${({ $isVisible }) => !$isVisible && { display: 'none' }}
`;
